<div *ngIf="informationPopupStore.loaded$ | async" class="popup-btn-wrapper">
  <ng-container *ngIf="expanded; then expandedBtn; else hiddenBtn"></ng-container>

  <ng-template #expandedBtn>
    <div class="popup-btn-content" (click)="closePopup()">
      <mat-icon>close</mat-icon>
    </div></ng-template
  >
  <ng-template #hiddenBtn>
    <div class="popup-btn-content" (click)="openPopup()">
      <mat-icon>info_outline</mat-icon>
    </div></ng-template
  >
</div>

<div class="popup-box-wrapper" *ngIf="expanded">
  <div class="popup-box-background"></div>
  <div class="popup-box-container">
    <div class="popup-box-content">
      <div>
        <h3 class="popup-box-title">{{ activePageConfig.titleKey | translate }}</h3>
        <vi-text size="medium" [content]="activePageConfig.descriptionKey | translate"> </vi-text>
      </div>
      <img class="popup-box-img" [src]="activePageConfig.imageUrl" alt="" />
    </div>
  </div>
</div>
